<template>
  <div class="box">
    <headerPage :orgInfo="org_info"/>
    <div class="bx-content">
      <div class="flex justify-between margin-top-sm margin-bottom-sm">
        <div class="left">
          <div class="title">
            <div class="name">专家详情</div>
            <div class="btn" @click="$router.go(-1)">
              <img src="../../assets/images/back.png" alt="">
              返回
            </div>
          </div>

<!--          <div class="logo">-->
<!--            <div class="img">-->
<!--              <img :src="logo" alt="">-->
<!--              <b>{{name}}</b>-->
<!--            </div>-->
<!--            <p @click="to">申请入驻</p>-->
<!--          </div>-->

          <div class="detail-box">
            <div class="d-left">
              <img :src="urlStr + detailCont.pic" alt="">
            </div>
            <div class="d-right">
              <div class="name">
                <b>{{detailCont.name}}</b>
                <span>|</span>
                <p>{{detailCont.expert_type}}</p>
              </div>
              <div class="tex">{{detailCont.job_text}}</div>
              <div class="fenl">
                <p>性别：{{detailCont.sex == 1 ? '男' : (detailCont.sex == 0 ? '' : '女')}}</p>
                <p>政治面貌：{{detailCont.political_status}}</p>
                <p>职称：{{detailCont.professional_title}}</p>
                <p>学历：{{detailCont.educational_background}}</p>
                <p>所属行业：{{detailCont.industry}}</p>
              </div>
              <div class="jies" v-html="detailCont.desc"></div>
              <div class="btn">
                <span @click="open(detailCont.id)">预约</span>
              </div>
            </div>
          </div>


        </div>
        <div class="right">
          <div class="tit">热门专家</div>
          <div class="list">
            <div class="item" v-for="item in hotList" :key="item.id">
              <div class="flex justify-between">
                <div class="tx"  @click="yuyueFun(item.id)" >
                  <img :src="urlStr + item.pic" alt="">
                </div>
                <div class="tex">
                  <b  @click="yuyueFun(item.id)" >{{item.name}}</b>
                  <p  @click="yuyueFun(item.id)" >{{item.expert_type}}</p>
                  <span @click="open(item.id)">预约</span>
                </div>
              </div>
              <div class="sd ovHide2"  @click="yuyueFun(item.id)" >{{item.job_text}}</div>
              <div class="xian"></div>
              <div class="ff" @click="yuyueFun(item.id)" >
                <el-tooltip effect="dark" :content="item.desc" placement="bottom" popper-class="tool-tip">
                  <p class="ovHide4">
                    {{item.desc}}
                    <!-- <span @click="yuyue(item.id)">【详情】</span>-->
                  </p>
                </el-tooltip>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <footerPage/>
    <el-dialog
        title=""
        :visible.sync="dialogFormVisible"
        custom-class="shenqBox"
        center
    >
      <div slot="title" style="font-size: 18px;font-weight:bold;">预约专家</div>
      <el-form :model="formA" :rules="rules" ref="formA" class="demo-ruleForm">
        <el-form-item label="姓名：" :label-width="formLabelWidth"  prop="name">
          <el-input v-model="formA.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" :label-width="formLabelWidth"  prop="tel" required>
          <el-input v-model="formA.tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="申请说明：" :label-width="formLabelWidth" prop="content">
          <el-input typr="textarea" v-model="formA.content" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="dialogFormVisible = false" style="width: 100px;height: 40px;">取 消</el-button>
        <el-button round type="primary" @click="submitForm('formA')" style="background-color: #ff9600;width: 100px;height: 40px;margin-left: 40px;border-color: #ff9600;">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import headerPage from '../home/common/headPage'
import footerPage from '../home/common/footPage'
import {hot, yuyueSub, zjDetail} from "@/api";
import {urlStr} from "@/config";
export default {

  name: "notLogin",
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      urlStr: urlStr,
      id:'',
      org_info:{},
      name:'',
      logo:'',
      tab:1,
      showId:'',
      info: true,
      yuyue:'',
      search: '',
      code:'http://fw.zhichenghui.org.cn',
      detailCont:{},
      hotList:[],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      show_config:{},
      formA: {
        name: '',
        content: '',
        tel: '',
      },
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入申请说明', trigger: 'blur' }
        ],
        tel: [
          { validator: validatePass, trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    headerPage,
    footerPage
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.id = this.$route.query.id
    this.name = this.$route.query.name
    this.logo = this.$route.query.logo
    this.yuyue = this.$route.query.yuyue
    this.showId = this.$route.query.showId
    this.org_info = {
      morglogo:this.$route.query.logo,
      morgname:this.$route.query.name,
      tel:this.$route.query.tel
    }
    this.detail()
    this.hot()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.sub()
        } else {
          this.$message.error('请检查是否填写完整');
          return false;
        }
      });
    },

    async sub(){
      let _res = await yuyueSub(
          this.user ? this.user.mid : '',
          this.showId,
          this.id,
          this.formA.name,
          this.formA.tel,
          this.formA.content,
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg);
        this.dialogFormVisible = false
      }else {
        this.$message.error(_res.msg);
      }
    },

    async detail(){
      let _res = await zjDetail(
          this.id
      );
      if (_res.status === 200) {
        this.detailCont = _res.data
        this.show_config = _res.data.org_info
        let ary = JSON.parse(this.detailCont.job)
        let arr = []
        ary.map(itm => {
          arr.push(itm.value)
        })
        this.detailCont.job_text = arr.join('、')
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 热门专家
    async hot(){
      let _res = await hot(
          this.showId,
          1,3
      );
      if (_res.status === 200) {
        var list = []
        list = _res.data;
        list.map(item => {
          let ary = JSON.parse(item.job)
          let arr = []
          ary.map(itm => {
            arr.push(itm.value)
          })
          item.job_text = arr.join('、')
        })
        this.hotList = list
      }else {
        this.$message.error(_res.msg);
      }
    },

    open(id){
      if(this.show_config.login_yuyue == 1 && !this.user) {
        this.$confirm('预约需要登录，是否去登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/login')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }else {
        this.id = id
        this.dialogFormVisible = true
      }
    },

    yuyueFun(id){
      this.id = id
      this.detail()
      this.$router.push({
        path: '/expertDetail',
        query: {
          id: id,
          name: this.name,
          logo: this.logo,
          showId: this.showId
        }
      })
    },

    // 跳转
    to() {
      this.$router.push({
        path: '/checkin',
        query: {
          register_type: 3,
          showId: this.showId
        }
      })
    },

  },
  watch: {}
}
</script>

<style scoped lang="scss">
.ff img {
  max-width: 100% ;
}

.box {
  width: 100%;
  background-color: #ffffff;
  .left {
    width: 944px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .name {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
      .btn {
        width: 100px;
        height: 40px;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        letter-spacing: 1px;
        color: #0a2240;
        cursor: pointer;
        img {
          width: 14px;
          height: 12px;
          margin-right: 2px;
        }
      }
    }
    .logo {
      width: 944px;
      height: 77px;
      background-color: rgba(243, 246, 249, .7);
      border-radius: 10px;
      padding: 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .img {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 36px;
          height: 36px;
          border-radius: 18px;
        }
        b {
          font-size: 20px;
          letter-spacing: 1px;
          color: #333333;
          font-weight: bold;
          margin-left: 10px;
        }
      }
      p {
        cursor: pointer;
        width: 119px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
      }
    }
    .detail-box {
      width: 100%;
      min-height: 600px;
      background-color: rgba(243, 246, 249, .7);
      border-radius: 10px;
      padding: 20px;
      display: flex;
      justify-content: space-between;

      .d-left {
        width: 225px;
        height: 268px;
        background-color: #f2f3f4;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      .d-right {
        width: 649px;
        .name {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          b {
            font-size: 28px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: bold;
          }
          span {
            color: #e2e2e2;
            margin: 0 15px;
          }
          p {
            font-size: 18px;
            letter-spacing: 1px;
            color: #333333;
          }
        }
        .tex {
          font-size: 14px;
          color: #333333;
          padding: 20px 0;
        }
        .fenl {
          width: 100%;
          padding: 15px;
          border-top: 1px solid #e2e2e2;
          border-bottom: 1px solid #e2e2e2;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          p {
            font-size: 14px;
            color: #666666;
            width: 33.33%;
            padding: 5px 0;
          }
        }
        .jies {
          font-size: 14px;
          color: #666666;
          line-height: 22px;
          padding-top: 15px;
          text-indent: 28px;

        }
        .btn {
          width: 100%;
          padding-top: 20px;
          span {
            display: block;
            width: 160px;
            height: 50px;
            cursor: pointer;
            background-image: linear-gradient(-27deg,
                #ff7e00 0%,
                #ffae00 100%),
            linear-gradient(
                    #ff9600,
                    #ff9600);
            background-blend-mode: normal,
            normal;
            box-shadow: 0px 5px 13px 0px
            rgba(255, 150, 0, 0.25);
            border-radius: 25px;
            font-size: 16px;
            letter-spacing: 2px;
            color: #ffffff;
            text-align: center;
            line-height: 50px;
          }
        }
      }
    }
  }
  .right {
    width: 232px;
    .tit {
      font-size: 20px;
      letter-spacing: 1px;
      color: #333333;
      font-weight: bold;
      line-height: 40px;
      padding-bottom: 15px;
    }
    .list {
      width: 100%;
      .item {
        width: 100%;
        height: 311px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #e2e2e2;
        padding: 12px;
        margin-bottom: 20px;
        .tx {
          width: 112px;
          height: 134px;
          background-color: #eaeff3;
          border-radius: 5px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        .tex {
          flex: 1;
          width: 0;
          margin-left: 12px;
          b {
            display: block;
            font-size: 20px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: bold;
            padding-top: 15px;
            cursor: pointer;
          }
          p {
            font-size: 14px;
            letter-spacing: 1px;
            color: #ff9600;
            padding: 15px 0;
            cursor: pointer;
          }
          span {
            cursor: pointer;
            display: block;
            width: 88px;
            height: 30px;
            background-color: #ff9600;
            border-radius: 15px;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            color: #ffffff;

          }
        }
        .sd {
          font-size: 14px;
          color: #999999;
          line-height: 22px;
          padding-top: 10px;
          cursor: pointer;
        }
        .xian {
          width: 100%;
          height: 1px;
          background-color: #ffffff;
          border: solid 1px #e2e2e2;
          margin: 10px 0;
        }
        .ff {
          font-size: 14px;
          color: #666666;
          line-height: 22px;
          position: relative;
          text-align: justify;
          cursor: pointer;
          span {
            position: absolute;
            bottom: 2px;
            right: 0;
            color: #ff9f03;
            font-size: 14px;
            background-color: #ffffff;
          }
        }
      }
    }
  }

}


</style>
